import { render, staticRenderFns } from "./InputForm.vue?vue&type=template&id=7ba6f6f8&scoped=true&"
import script from "./InputForm.vue?vue&type=script&lang=js&"
export * from "./InputForm.vue?vue&type=script&lang=js&"
import style0 from "./InputForm.vue?vue&type=style&index=0&id=7ba6f6f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba6f6f8",
  null
  
)

export default component.exports